import { ZnifferCommand } from "./command.js";
